var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import deprecated from 'react-prop-types/lib/deprecated';
import isRequiredForA11y from 'react-prop-types/lib/isRequiredForA11y';
import controlled from '../utils/PropTypes/controlled';
import getDeprecatedIcon from '../FontIcons/getDeprecatedIcon';
import FontIcon from '../FontIcons/FontIcon';
import SelectionControl from './SelectionControl';

/**
 * The `Checkbox` component is used for the selection of multiple options from a set.
 */

var Checkbox = function (_PureComponent) {
  _inherits(Checkbox, _PureComponent);
  function Checkbox() {
    _classCallCheck(this, Checkbox);
    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
  }
  Checkbox.prototype.render = function render() {
    var _props = this.props,
      checkedIcon = _props.checkedIcon,
      uncheckedIcon = _props.uncheckedIcon,
      checkedIconChildren = _props.checkedIconChildren,
      checkedIconClassName = _props.checkedIconClassName,
      uncheckedIconChildren = _props.uncheckedIconChildren,
      uncheckedIconClassName = _props.uncheckedIconClassName,
      props = _objectWithoutProperties(_props, ['checkedIcon', 'uncheckedIcon', 'checkedIconChildren', 'checkedIconClassName', 'uncheckedIconChildren', 'uncheckedIconClassName']);
    var checked = getDeprecatedIcon(checkedIconClassName, checkedIconChildren, checkedIcon);
    var unchecked = getDeprecatedIcon(uncheckedIconClassName, uncheckedIconChildren, uncheckedIcon);
    return React.createElement(SelectionControl, _extends({
      type: 'checkbox',
      checkedCheckboxIcon: checked,
      uncheckedCheckboxIcon: unchecked,
      __superSecreteProp: true
    }, props));
  };
  return Checkbox;
}(PureComponent);
Checkbox.propTypes = {
  /**
   * An id to use with the checkbox. This is used for accessibility and so that the label
   * triggers the checkbox toggle.
   */
  id: isRequiredForA11y(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  /**
   * An optional style to apply to the checkbox's container.
   */
  style: PropTypes.object,
  /**
   * An optional className to apply to the checkbox's container.
   */
  className: PropTypes.string,
  /**
   * A label to display with the checkbox. This is required for accessibility and triggering
   * the toggle.
   */
  label: PropTypes.node,
  /**
   * Boolean if the label should appear before the checkbox icon.
   */
  labelBefore: PropTypes.bool,
  /**
   * A name to use for the `Checkbox`. This is required for accessibility. If the checkbox is
   * part of a group, it is recommended to make this a string ending in `[]` so that the
   * value can be found from `document.querySelector('input[name="someName[]"]').value`.
   */
  name: isRequiredForA11y(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
  /**
   * Boolean if the `Checkbox` is disabled.
   */
  disabled: PropTypes.bool,
  /**
   * An optional function to call when the `checked` state of the `Checkbox` changes.
   * The callback will include the new checked state and the changeEvent.
   *
   * ```js
   * onChange(changeEvent.target.checked, changeEvent);
   * ```
   */
  onChange: PropTypes.func,
  /**
   * An optional value for the `Checkbox`. It is recommended to use a value though.
   */
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string]),
  /**
   * Boolean if the `Checkbox` is checked by default.
   */
  defaultChecked: PropTypes.bool,
  /**
   * A boolean if the `Checkbox` is currently checked. This will required the `onChange` prop
   * to be defined.
   */
  checked: controlled(PropTypes.bool, 'onChange', 'defaultChecked'),
  /**
   * Boolean if the `Checkbox` should be displayed inline.
   */
  inline: PropTypes.bool,
  /**
   * Whether the `change` event should be triggered for `Checkbox` on pressing of `Enter` key.
   */
  changeOnEnter: PropTypes.bool,
  /**
   * The icon to display when the checkbox is checked.
   */
  checkedIcon: PropTypes.node,
  /**
   * The icon to display when the checkbox is unchecked.
   */
  uncheckedIcon: PropTypes.node,
  checkedIconChildren: deprecated(PropTypes.node, 'Use `checkedIcon` instead'),
  checkedIconClassName: deprecated(PropTypes.string, 'Use `checkedIcon` instead'),
  uncheckedIconChildren: deprecated(PropTypes.node, 'Use `uncheckedIcon` instead'),
  uncheckedIconClassName: deprecated(PropTypes.string, 'Use `uncheckedIcon` instead')
};
Checkbox.defaultProps = {
  checkedIcon: React.createElement(FontIcon, null, 'check_box'),
  uncheckedIcon: React.createElement(FontIcon, null, 'check_box_outline_blank')
};
export default Checkbox;